// Category Cards Carousel
// La funcionalidad principal está en el script inline del liquid
// Este archivo se mantiene para evitar errores 404

console.log('Category Cards carousel loaded');
